import { getVisitTypeUrl } from '@router/utils';
import { convertTimeToDayjs } from '@utils/datetime/convertTimeToDayjs';
import dayjs from 'dayjs';
import { TimeBlock } from '../context/utils';

export function buildViewAllUrl(
  visitTypeId: string,
  providerId: string,
  timeBlock: TimeBlock | null,
) {
  const date =
    timeBlock === 'tomorrow'
      ? dayjs().add(1, 'day').format('YYYY-MM-DD')
      : undefined;

  return `${getVisitTypeUrl(visitTypeId, date)}&providerId=${providerId}`;
}

export function formatAppointmentTime(time: string) {
  const appointmentTime = convertTimeToDayjs(time);

  return appointmentTime.format('h:mm A');
}

export function getMinutesUntilAppointment(time: string): number {
  const appointmentTime = convertTimeToDayjs(time);
  const now = dayjs();
  const minutesUntilAppointment = appointmentTime.diff(now, 'minute');

  return minutesUntilAppointment;
}

export function getTimeUntilAppointment(
  time: string,
  timeBlock: TimeBlock | null,
): string {
  if (timeBlock === 'today' || timeBlock === 'tomorrow') {
    const [hour, minute] = time.split(':').map(Number);

    const baseDay = dayjs()
      .add(timeBlock === 'tomorrow' ? 1 : 0, 'day')
      .startOf('day')
      .set('second', 0)
      .set('millisecond', 0);
    const endOfMorning = baseDay.set('hour', 12).set('minute', 0);
    const endOfAfternoon = baseDay.set('hour', 17).set('minute', 0);

    const appointmentTime = baseDay.set('hour', hour).set('minute', minute);

    if (appointmentTime.isBefore(endOfMorning)) {
      return 'Morning';
    } else if (appointmentTime.isBefore(endOfAfternoon)) {
      return 'Afternoon';
    } else {
      return 'Evening';
    }
  }

  const minutesUntilAppointment = getMinutesUntilAppointment(time);

  return `in ${minutesUntilAppointment} min`;
}
